import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/protected/_layout/document-payment-schedules/_layout/'
)({
  component: () => null,
});
